/**
 * clerk-js buildSignInUrl() on satellite pages (e.g. the Ring account-link
 * page on connect.getseam.com) targets the primary's hash-routed <SignIn>
 * component, so it appends its redirect params AFTER the hash:
 *
 *   /signin#/?sign_in_force_redirect_url=...&redirect_url=...
 *
 * Next's router.query only sees the real query string, so those params are
 * invisible to it — reading only router.query silently drops the satellite
 * return target and strands the user on the dashboard. Parse the params out
 * of location.hash instead.
 */
export const getClerkHashParams = (hash: string): Record<string, string> => {
  const questionIndex = hash.indexOf("?")
  if (questionIndex === -1) return {}
  const params = new URLSearchParams(hash.slice(questionIndex + 1))
  return Object.fromEntries(params.entries())
}
